import config from 'config';
import React, { Component } from 'react';
import axios from '../lib/axios';
import InlineSVG from './InlineSVG';



export default class ShareContent extends Component{
  constructor(props) {
    super(props);
    this.state = { showingShareEmail: false, isSending: false, email: '' };
  }
  
  openEmailPopup(ev) {
    ev.preventDefault();
		ev.stopPropagation();
		this.setState({ showingShareEmail: true }, () => this.refs.email.focus());
	}

	closeEmailPopup(ev) {
		this.setState({ showingShareEmail: false });
	}

  handleSubmitShareEmail(ev) {
		ev.preventDefault();
		let regexEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const isValid = regexEmail.test(this.state.email);

		const successCallback = (result) => this.setState({
			isSending: false,
			showingShareEmail: false,
			email: ''
		});

		if (isValid) {
			this.setState({ isSending: true });
			axios.post('/share', {
				filePath: this.props.filePath,
				to: this.state.email,
      }).then(
        successCallback
      ).catch(successCallback);
      
		}
  }
  render(){
    return(
      <div className="share-content">
        { this.state.showingShareEmail &&
          <div className="share-email" onClick={(ev) => ev.stopPropagation()}>
            <form onSubmit={this.handleSubmitShareEmail.bind(this)}>
              <input ref="email" type="email" name="email" placeholder="Digite o e-mail" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} />
              <button className={ this.state.isSending ? 'disabled' : '' }>
                <InlineSVG src={require('../img/icon-btn-email.svg')} alt="E-mail" />
              </button>
            </form>
            <button onClick={() => this.setState({ showingShareEmail: false})} title="Cancelar">
              <InlineSVG src={require('../img/icon-plus.svg')} alt="Cancelar" />
            </button>
          </div>
          }
        <p>Compartilhar</p>
        <a target="_blank" title="Whatsapp" className="link" href={`https://wa.me/send?text=Confira este material do Speed Content. ${config.app.baseURL}${this.props.filePath}`}>
         <InlineSVG src={require('../img/icon-btn-whatsapp.svg')} alt="Whatsapp" />
        </a>
        <button title="E-mail" onClick={ev => this.openEmailPopup(ev)} className="link">
          <InlineSVG src={require('../img/icon-btn-email.svg')} alt="E-mail" />
        </button>
      </div>  
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ShareContent.js